import React from 'react';
import { Button } from '../Button/Button.esm.js';
import '@panwds/icons';
import '@panwds/tailwindcss';
import '@popperjs/core';
import '../Icon/ImgIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';
import '../Button/ProgressButton.esm.js';
import '../Button/CopyButton.esm.js';
import { useModalContext } from './Modal.esm.js';

/**
 * A Button that when clicked, will call closeModal
 * with the confirm close logic if confirmClose is true on Modal.
 */
const ModalCloseButton = ({ children, ...props }) => {
    const { closeModalWithConfirm } = useModalContext();
    return (React.createElement(Button, { "data-testid": "modal-close-button", onClick: closeModalWithConfirm, addClassName: "tw-bg-transparent", ...props }, children));
};

export { ModalCloseButton };
//# sourceMappingURL=ModalCloseButton.esm.js.map
